<template>
  <div class="dhr-sideview no-padding">
    <div class="subparts-menu" v-if="totalSamples > 0">
      <div 
        v-for="index in totalSamples" 
        :key="index"
        class="menu-link"
        :class="{'link active active-line': selectedSample == index || hoveredSample == index}"
        @mouseover="hoverRow(index)"
        @mouseout="hoverRow(null)"
        @click="selectRow(index)"
      >
        {{ "Sample " + index}}
      </div>
    </div>

    <div class="subparts-menu" v-else>
      <div 
        class="menu-link link active active-line"
      >
        {{ "Sample example" }}
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";

export default {
  components: {
    BaseIcon,
  },
  computed: {
    // filteredSamples: function () {
    //   let filteredArray = this.data.filter((sample, index, self) =>
    //     index === self.findIndex((t) => (
    //       t.number === sample.number
    //     ))
    //   )
    //   return filteredArray
    // }
  },
  props: {
    data: Array,
    totalSamples: Number
  },
  mounted() {
    this.selectRow(1)
  },
  data() {
    return {
      selectedSample: 0,
      hoveredSample: null
    };
  },
  methods: {
    selectRow(sampleNr) {
      this.selectedSample = sampleNr
      this.$emit("selectedInspection", sampleNr);
    },
    hoverRow(sampleNr) {
      this.hoveredSample = sampleNr
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/dhrdetail.scss";
@import "@/style/components/active.scss";

</style>